import { useState } from 'react'
import { ContractUnion } from '@synapex/shared2/gateway-rest-api'
import { toast } from 'react-toastify'

type CustomContractFormValues = {
    number: string
    date: Date
}

export function useCustomContract(contracts: ContractUnion[] | undefined) {
    const [customContractFormOpen, setCustomContractFormOpen] = useState(false)
    const [customContractFormMode, setCustomContractFormMode] = useState<
        'create' | 'edit'
    >('create')
    const [customContractInitialValues, setCustomContractInitialValues] =
        useState<CustomContractFormValues | undefined>(undefined)
    const [editingCustomContractId, setEditingCustomContractId] = useState<
        number | null
    >(null)

    function handleEditCustomContract(customContractId: number) {
        const customContract = contracts?.find(
            (
                contract
            ): contract is Extract<ContractUnion, { type: 'custom' }> =>
                contract.type === 'custom' &&
                contract.custom_contract_id === customContractId
        )

        if (!customContract) {
            toast.error('Не удалось найти договор для редактирования')
            return
        }

        const contractDate =
            customContract.start_date instanceof Date
                ? customContract.start_date
                : new Date(customContract.start_date)

        setCustomContractFormMode('edit')
        setCustomContractInitialValues({
            number: customContract.number,
            date: contractDate,
        })
        setEditingCustomContractId(customContractId)
        setCustomContractFormOpen(true)
    }

    function handleCustomContractFormOpenChange(open: boolean) {
        setCustomContractFormOpen(open)
        if (!open) {
            setCustomContractFormMode('create')
            setCustomContractInitialValues(undefined)
            setEditingCustomContractId(null)
        }
    }

    function openCreateForm() {
        setCustomContractFormMode('create')
        setCustomContractInitialValues(undefined)
        setEditingCustomContractId(null)
        setCustomContractFormOpen(true)
    }

    return {
        customContractFormOpen,
        customContractFormMode,
        customContractInitialValues,
        editingCustomContractId,
        handleEditCustomContract,
        handleCustomContractFormOpenChange,
        openCreateForm,
    }
}


